import { Map, List, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import {
  applyPopulatedEvtInputsToEvtInputs,
  clearPopulatedEvtInputsFromEvtInputs,
} from 'routes/App/Apps/MyJobs/Common/utils'
import {
  ACTION_DELETE,
  ACTION_DUPLICATE,
  ACTION_DUPLICATE_WITH_DATA,
} from 'constants/index'

// constants
export const FETCH_JOB_LIST = 'myJobs/FETCH_JOB_LIST'
export const SUCCESS_JOB_LIST = 'myJobs/SUCCESS_JOB_LIST'
export const FAILURE_JOB_LIST = 'myJobs/FAILURE_JOB_LIST'
export const LOAD_JOB_LIST = 'myJobs/LOAD_JOB_LIST'

export const FETCH_ASSIGN_DATA = 'myJobs/FETCH_ASSIGN_DATA'
export const SUCCESS_ASSIGN_DATA = 'myJobs/SUCCESS_ASSIGN_DATA'
export const FAILURE_ASSIGN_DATA = 'myJobs/FAILURE_ASSIGN_DATA'
export const LOAD_ASSIGN_DATA = 'myJobs/LOAD_ASSIGN_DATA'
export const UPDATE_TASK_ASSIGNEES = 'myJobs/UPDATE_TASK_ASSIGNEES'
export const [UPDATE_TASK_ASSIGNEES_SUCCESS, UPDATE_TASK_ASSIGNEES_FAILURE] = [
  `${UPDATE_TASK_ASSIGNEES}_SUCCESS`,
  `${UPDATE_TASK_ASSIGNEES}_FAILURE`,
]

export const FETCH_JOB_TASK_LIST = 'myJobs/FETCH_JOB_TASK_LIST'
export const SUCCESS_TASK_LIST = 'myJobs/SUCCESS_TASK_LIST'
export const FAILURE_TASK_LIST = 'myJobs/FAILURE_TASK_LIST'
export const LOAD_TASK_LIST = 'myJobs/LOAD_TASK_LIST'

export const FETCH_JOB_FILTERS_DATA = 'myJobs/FETCH_JOB_FILTERS_DATA'
export const SUCCESS_JOB_FILTERS_DATA = 'myJobs/SUCCESS_JOB_FILTERS_DATA'
export const FAILURE_JOB_FILTERS_DATA = 'myJobs/FAILURE_JOB_FILTERS_DATA'

export const SET_JOB_FILTERS = 'myJobs/SET_JOB_FILTERS'

export const SAVE_JOB_TASK_INPUT = 'myJobs/SAVE_JOB_TASK_INPUT'
export const UPDATE_JOB_TASK_INPUT = 'myJobs/UPDATE_JOB_TASK_INPUT'
export const SET_EVT_INPUT_RESULT = 'myJobs/SET_EVT_INPUT_RESULT'
export const CLEAR_EVT_INPUTS_RESULTS = 'myJobs/CLEAR_EVT_INPUTS_RESULTS'
export const SET_EVT_INPUTS_RESULTS = 'myJobs/SET_EVT_INPUTS_RESULTS'
export const SAVE_JOB_MULTI_TASK_INPUTS = 'myJobs/SAVE_JOB_MULTI_TASK_INPUTS'
export const UPDATE_JOB_MULTI_TASK_INPUTS =
  'myJobs/UPDATE_JOB_MULTI_TASK_INPUTS'
export const CREATE_EVT_JOB_TASK = 'myJobs/CREATE_EVT_JOB_TASK'
export const CREATE_EVT_JOB_MULTI_TASK = 'myJobs/CREATE_EVT_JOB_MULTI_TASK'
export const LOAD_EVT_JOB_TASK = 'myJobs/LOAD_EVT_JOB_TASK'
export const LOAD_JOB_TASK_INPUT = 'myJobs/LOAD_JOB_TASK_INPUT'
export const UPDATE_JOB_TASK = 'myJobs/UPDATE_JOB_TASK'
export const UPDATE_JOB_ITEM = 'myJobs/UPDATE_JOB_ITEM'
export const DELETE_JOB_ITEM = 'myJobs/DELETE_JOB_ITEM'
export const DELETE_TASK_ITEM = 'myJobs/DELETE_TASK_ITEM'
export const UPDATE_JOB_LOAD = 'myJobs/UPDATE_JOB_LOAD'

export const FETCH_WORKFLOW_LIST = 'myJobs/FETCH_WORKFLOW_LIST'
export const SUCCESS_WORKFLOW_LIST = 'myJobs/SUCCESS_WORKFLOW_LIST'
export const FAILURE_WORKFLOW_LIST = 'myJobs/FAILURE_WORKFLOW_LIST'

export const FETCH_LOOKUP_TABLE_SOURCE_DATA =
  'myJobs/FETCH_LOOKUP_TABLE_SOURCE_DATA'
export const [
  FETCH_LOOKUP_TABLE_SOURCE_DATA_SUCCESS,
  FETCH_LOOKUP_TABLE_SOURCE_DATA_FAILURE,
] = [
  `${FETCH_LOOKUP_TABLE_SOURCE_DATA}_SUCCESS`,
  `${FETCH_LOOKUP_TABLE_SOURCE_DATA}_FAILURE`,
]
export const HANDLE_DEPENDENT_LOOKUP_INPUTS =
  'myJobs/HANDLE_DEPENDENT_LOOKUP_INPUTS'

export const ADD_DYNAMIC_OPTION = 'myJobs/ADD_DYNAMIC_OPTION'
export const DUPLICATE_INPUT_GROUP = 'myJobs/DUPLICATE_INPUT_GROUP'
export const DELETE_DUPLICATED_INPUT_GROUP =
  'myJobs/DELETE_DUPLICATED_INPUT_GROUP'
export const DELETE_INPUT_PREVIEWS = 'myJobs/DELETE_INPUT_PREVIEWS'

export const FETCH_WORKFLOW_INFO = 'myJobs/FETCH_WORKFLOW_INFO'
export const SUCCESS_TASK_UPDATE = 'myJobs/SUCCESS_TASK_UPDATE'
export const SUCCESS_WORKFLOW_INFO = 'myJobs/SUCCESS_WORKFLOW_INFO'
export const FAILURE_WORKFLOW_INFO = 'myJobs/FAILURE_WORKFLOW_INFO'
export const CREATE_JOB = 'myJobs/CREATE_JOB'
export const [CREATE_JOB_SUCCESS, CREATE_JOB_FAILURE] = [
  `${CREATE_JOB}_SUCCESS`,
  `${CREATE_JOB}_FAILURE`,
]
export const RELOAD_JOB_LIST = 'myJobs/RELOAD_JOB_LIST'
const SET_ACTIVE_SITE = 'myJobs/SET_ACTIVE_SITE'
const SET_ACTIVE_STATE = 'myJobs/SET_ACTIVE_STATE'
const CLEAR_STORE = 'myJobs/CLEAR_STORE'
const RESET_TASK_LIST = 'myJobs/RESET_TASK_LIST'
export const RESET_DATA = 'myJobs/RESET_DATA'
export const RESET_INVALID_DATES = 'myJobs/RESET_INVALID_DATES'
export const SET_PREVIEW_INPUTS = 'myJobs/SET_PREVIEW_INPUTS'
export const UPDATE_TASK_PREVIEW_INPUTS = 'myJobs/UPDATE_TASK_PREVIEW_INPUTS'

export const EVALUATE_CALCULATION_FIELDS = 'myJobs/EVALUATE_CALCULATION_FIELDS'

export const SAVE_DUPLICATED_GROUP_ID = 'myJobs/SAVE_DUPLICATED_GROUP_ID'
export const REMOVE_DUPLICATED_GROUP_ID = 'myJobs/REMOVE_DUPLICATED_GROUP_ID'

export const UPLOAD_FILE_FROM_DATA_URL = 'myJobs/UPLOAD_FILE_FROM_DATA_URL'

export const FETCH_JOB_REPORT_PDF = 'FETCH_JOB_REPORT_PDF'
export const [FETCH_JOB_REPORT_PDF_SUCCESS, FETCH_JOB_REPORT_PDF_FAILURE] = [
  `${FETCH_JOB_REPORT_PDF}_SUCCESS`,
  `${FETCH_JOB_REPORT_PDF}_FAILURE`,
]

// actions
export const fetchJobList = ActionHelper.createActionObj(FETCH_JOB_LIST)
export const fetchAssignData = ActionHelper.createActionObj(FETCH_ASSIGN_DATA)
export const fetchJobTaskList = ActionHelper.createActionObj(
  FETCH_JOB_TASK_LIST,
)
export const fetchJobFiltersData = ActionHelper.createActionObj(
  FETCH_JOB_FILTERS_DATA,
)
export const reloadJobList = ActionHelper.createActionObj(RELOAD_JOB_LIST)
export const saveJobTaskInput = ActionHelper.createActionObj(
  SAVE_JOB_TASK_INPUT,
)
export const updateJobTaskInput = ActionHelper.createActionObj(
  UPDATE_JOB_TASK_INPUT,
)
export const saveJobMultiTaskInputs = ActionHelper.createActionObj(
  SAVE_JOB_MULTI_TASK_INPUTS,
)
export const updateJobMultiTaskInputs = ActionHelper.createActionObj(
  UPDATE_JOB_MULTI_TASK_INPUTS,
)
export const createEvtJobTask = ActionHelper.createActionObj(
  CREATE_EVT_JOB_TASK,
)
export const createEvtJobMultiTask = ActionHelper.createActionObj(
  CREATE_EVT_JOB_MULTI_TASK,
)
export const deleteJob = ActionHelper.createActionObj(DELETE_JOB_ITEM)
export const updateJob = ActionHelper.createActionObj(UPDATE_JOB_ITEM)
export const updateTaskAssignees = ActionHelper.createActionObj(
  UPDATE_TASK_ASSIGNEES,
)
export const deleteTask = ActionHelper.createActionObj(DELETE_TASK_ITEM)
export const fetchWorkflowList = ActionHelper.createActionObj(
  FETCH_WORKFLOW_LIST,
)
export const fetchWorkflowInfo = ActionHelper.createActionObj(
  FETCH_WORKFLOW_INFO,
)
export const createJob = ActionHelper.createActionObj(CREATE_JOB)
export const createJobSuccess = ActionHelper.createActionObj(CREATE_JOB_SUCCESS)
export const createJobFailure = ActionHelper.createActionObj(CREATE_JOB_FAILURE)
export const updateJobTask = ActionHelper.createActionObj(UPDATE_JOB_TASK)
export const setActiveSite = ActionHelper.createActionObj(SET_ACTIVE_SITE)
export const setActiveState = ActionHelper.createActionObj(SET_ACTIVE_STATE)
export const setJobFilters = ActionHelper.createActionObj(SET_JOB_FILTERS)
export const resetTasks = ActionHelper.createActionObj(RESET_TASK_LIST)
export const clearStore = ActionHelper.createActionObj(CLEAR_STORE)
export const resetInvalidDates = ActionHelper.createActionObj(
  RESET_INVALID_DATES,
)
export const addDynamicOption = ActionHelper.createActionObj(ADD_DYNAMIC_OPTION)
export const duplicateInputGroup = ActionHelper.createActionObj(
  DUPLICATE_INPUT_GROUP,
)
export const deleteDuplicatedInputGroup = ActionHelper.createActionObj(
  DELETE_DUPLICATED_INPUT_GROUP,
)
export const evaluateCalculationFields = ActionHelper.createActionObj(
  EVALUATE_CALCULATION_FIELDS,
)
export const fetchLookupTableSourceData = ActionHelper.createActionObj(
  FETCH_LOOKUP_TABLE_SOURCE_DATA,
)
export const handleDependentLookupInputs = ActionHelper.createActionObj(
  HANDLE_DEPENDENT_LOOKUP_INPUTS,
)
export const resetData = ActionHelper.createActionObj(RESET_DATA)
export const setPreviewInputs = ActionHelper.createActionObj(SET_PREVIEW_INPUTS)
export const updateTaskPreviewInputs = ActionHelper.createActionObj(
  UPDATE_TASK_PREVIEW_INPUTS,
)
export const uploadFileFromDataUrl = ActionHelper.createActionObj(
  UPLOAD_FILE_FROM_DATA_URL,
)

export const clearEvtInputsResults = ActionHelper.createActionObj(
  CLEAR_EVT_INPUTS_RESULTS,
)

export const fetchJobReportPdf = ActionHelper.createActionObj(
  FETCH_JOB_REPORT_PDF,
)

// store
const initialState = () =>
  fromJS({
    loading: false,
    jobCreationLoading: false,
    isLoadJobList: false,
    isLoadAssignData: false,
    isReloadJobList: false,
    isWorkflowListLoad: false,
    isLoadTaskList: false,
    isWorkflowInfoLoad: false,
    isLoadEvtTask: false,
    isLoadJobInput: false,
    isJobUpdating: false,
    activeSite: null,
    jobList: [],
    jobTask: {},
    workflowList: [],
    previewInputs: [],
    workflowInfo: {
      id: null,
      title: null,
      needs_locus: false,
      needs_locus_group: false,
      tasks: [],
    },
    assignData: {
      groupList: [],
      userList: [],
    },
    jobsFiltersData: {
      workflows: null,
      creators: [],
      assignees: [],
      locusesAndGroups: {},
      triggerRule: [],
    },
    jobsFilters: {
      site: null,
      preset: 'active',
      workflow: [],
      created_by: [],
      assignee: [],
      units: [],
    },
    preset: 'active',
    duplicatedGroupsIds: [],
  })

const myJobs = handleActions(
  {
    [SUCCESS_JOB_LIST]: (state, action) => {
      const {
        payload: { response, page },
      } = action
      const { jobList } = state.toJS()
      const newJobList = page > 1 ? [...jobList, ...response] : response
      const previewInputs = newJobList.reduce(
        (inputs, { preview_inputs, id }) =>
          preview_inputs
            ? [
                ...inputs,
                ...preview_inputs.map(preview_input => ({
                  ...preview_input,
                  jobId: id,
                })),
              ]
            : inputs,
        [],
      )

      return state
        .set('jobList', List(newJobList))
        .set('previewInputs', previewInputs)
    },
    [FAILURE_JOB_LIST]: state =>
      state.set('jobList', initialState().get('jobList')),
    [LOAD_JOB_LIST]: (state, action) =>
      state.set('isLoadJobList', action.payload),
    [RELOAD_JOB_LIST]: state =>
      state.set('isReloadJobList', Boolean(!state.get('isReloadJobList'))),
    [UPDATE_TASK_ASSIGNEES]: state => state.set('loading', true),
    [combineActions(
      UPDATE_TASK_ASSIGNEES_SUCCESS,
      UPDATE_TASK_ASSIGNEES_FAILURE,
    )]: state => state.set('loading', false),
    [SUCCESS_ASSIGN_DATA]: (state, action) =>
      state.set('assignData', fromJS(action.payload)),
    [FAILURE_ASSIGN_DATA]: state =>
      state.set('assignData', initialState().get('assignData')),
    [LOAD_ASSIGN_DATA]: (state, action) =>
      state.set('isLoadAssignData', Boolean(action.payload)),
    [LOAD_TASK_LIST]: (state, action) =>
      state.set('isLoadTaskList', action.payload),
    [LOAD_EVT_JOB_TASK]: (state, action) =>
      state.set('isLoadEvtTask', action.payload),
    [LOAD_JOB_TASK_INPUT]: (state, action) =>
      state.set('isLoadJobInput', action.payload),
    [SUCCESS_TASK_LIST]: (state, action) =>
      state.set('jobTask', Map(action.payload)),
    [FAILURE_TASK_LIST]: state =>
      state.set('jobTask', initialState().get('jobTask')),
    [FETCH_WORKFLOW_LIST]: state => state.set('isWorkflowListLoad', true),
    [SUCCESS_WORKFLOW_LIST]: (state, action) =>
      state
        .set('workflowList', List(action.payload))
        .set('isWorkflowListLoad', false),
    [FAILURE_WORKFLOW_LIST]: state =>
      state
        .set('workflowList', initialState().get('workflowList'))
        .set('isWorkflowListLoad', false),
    [FETCH_WORKFLOW_INFO]: state => state.set('isWorkflowInfoLoad', true),
    [SUCCESS_WORKFLOW_INFO]: (state, action) =>
      state
        .set('workflowInfo', Map(action.payload))
        .set('isWorkflowInfoLoad', false),
    [FAILURE_WORKFLOW_INFO]: state =>
      state
        .set('workflowInfo', initialState().get('workflowInfo'))
        .set('isWorkflowInfoLoad', false),
    [SUCCESS_JOB_FILTERS_DATA]: (state, action) =>
      state.set('jobsFiltersData', Map(action.payload)),
    [FAILURE_JOB_FILTERS_DATA]: state =>
      state.set('jobsFiltersData', initialState().get('jobsFiltersData')),
    [SET_JOB_FILTERS]: (state, action) =>
      state.set('jobsFilters', Map(action.payload)),
    [SET_ACTIVE_SITE]: (state, action) =>
      state.set('activeSite', Map(action.payload)),
    [SET_ACTIVE_STATE]: (state, action) => state.set('preset', action.payload),
    [RESET_TASK_LIST]: state => state.set('jobTask', Map({})),
    [UPDATE_JOB_LOAD]: (state, action) =>
      state.set('isJobUpdating', action.payload),
    [RESET_INVALID_DATES]: (state, action) => {
      const { invalidDates, currentTaskID, currentEvtTaskID } = action.payload
      const jobTask = state.get('jobTask').toObject()

      const evtTask = jobTask.tasks
        .find(({ id }) => id === currentTaskID)
        .evt_tasks.find(({ id }) => currentEvtTaskID === id)

      const newInputs = []
      evtTask.evt_inputs.forEach(input => {
        if (!invalidDates.includes(input.input)) {
          newInputs.push(input)
        }
      })

      evtTask.evt_inputs = newInputs

      return state.set('jobTask', Map(jobTask))
    },
    [FETCH_LOOKUP_TABLE_SOURCE_DATA_SUCCESS]: (state, action) => {
      const jobTask = state.get('jobTask').toObject()
      const { taskId, inputItemId, options, orderedChoices } = action.payload
      const taskMatch = jobTask.tasks.find(({ id }) => id === taskId)
      const taskInputs = []

      taskMatch.input_items.forEach(input_item => {
        if (input_item.input_item_type === 'input') {
          taskInputs.push(input_item)
        } else {
          input_item.inputs.forEach(input => {
            taskInputs.push(input)
          })
        }
      })

      const inputItemMatch = taskInputs.find(({ id }) => id === inputItemId)

      inputItemMatch.options = options
      if (orderedChoices.length)
        inputItemMatch.parameters.ordered_choices = orderedChoices

      return state.set('jobTask', Map(jobTask))
    },
    [SUCCESS_TASK_UPDATE]: (state, { payload: { jobId, action } }) => {
      const { jobList } = state.toJS()
      const jobMatch = jobList.find(({ id }) => id === jobId)

      if (
        action === ACTION_DUPLICATE_WITH_DATA ||
        action === ACTION_DUPLICATE
      ) {
        jobMatch.tasks_total += 1
      }

      if (action === ACTION_DELETE) {
        jobMatch.tasks_total -= 1
      }

      return state
    },
    [DELETE_INPUT_PREVIEWS]: (state, { payload: { previewsToRemove } }) => {
      const { previewInputs } = state.toJS()

      const newPreviews = previewInputs.filter(
        ({ evt_input_id }) => !previewsToRemove.find(id => id === evt_input_id),
      )

      return state.set('previewInputs', newPreviews)
    },
    [CREATE_JOB]: state => state.set('jobCreationLoading', true),
    [CREATE_JOB_SUCCESS]: state => state.set('jobCreationLoading', false),
    [CREATE_JOB_FAILURE]: state => state.set('jobCreationLoading', false),
    [SET_PREVIEW_INPUTS]: (state, { payload }) =>
      state.set('previewInputs', payload),
    [UPDATE_TASK_PREVIEW_INPUTS]: (state, { payload }) => {
      const job = state.get('jobTask').toObject()
      const { tasks } = job
      const { taskId, previewInputs: newPreviewInputs } = payload
      const taskIndex = tasks?.findIndex(({ id }) => id === taskId)

      if (taskIndex >= 0 && newPreviewInputs?.length) {
        const task = tasks[taskIndex]
        task.preview_inputs = newPreviewInputs
        tasks[taskIndex] = task
        job.tasks = tasks
      }

      return state.set('jobTask', Map(job))
    },
    [SAVE_DUPLICATED_GROUP_ID]: (state, { payload: { id } }) => {
      const { duplicatedGroupsIds } = state.toJS()

      return state.set('duplicatedGroupsIds', [...duplicatedGroupsIds, id])
    },
    [REMOVE_DUPLICATED_GROUP_ID]: (state, { payload }) => {
      const { duplicatedGroupsIds } = state.toJS()

      return state.set(
        'duplicatedGroupsIds',
        duplicatedGroupsIds.filter(id => id !== payload),
      )
    },
    [CLEAR_EVT_INPUTS_RESULTS]: (state, { payload }) => {
      const { currentTaskID, currentEvtTaskID, clearedEvtInputs } = payload
      const job = state.get('jobTask').toObject()

      // Create a deep copy of the job object
      const newJob = JSON.parse(JSON.stringify(job))

      const taskIndex = newJob.tasks.findIndex(({ id }) => id === currentTaskID)
      if (taskIndex >= 0) {
        const evtTaskIndex = newJob.tasks[taskIndex].evt_tasks.findIndex(
          ({ id }) => id === currentEvtTaskID,
        )

        if (evtTaskIndex >= 0) {
          const evtTask = newJob.tasks[taskIndex].evt_tasks[evtTaskIndex]
          const currentEvtInputs = evtTask.evt_inputs || []

          // Create a new array for evt_inputs with cleared results
          const newInputs = currentEvtInputs.map(evtInput => {
            if (evtInput.result && clearedEvtInputs.includes(evtInput.id)) {
              // Create a new object with cleared result
              return {
                ...evtInput,
                result: Array.isArray(evtInput.result) ? [] : null,
              }
            }

            // Return the original input if not cleared
            return { ...evtInput }
          })

          // Assign the new array to evt_inputs
          evtTask.evt_inputs = newInputs
        }
      }

      return state.set('jobTask', Map(newJob))
    },
    [SET_EVT_INPUTS_RESULTS]: (state, { payload }) => {
      const {
        currentTaskID,
        currentEvtTaskID,
        evtInputs,
        inputId,
        result,
      } = payload
      const job = state.get('jobTask').toObject()
      const newJob = JSON.parse(JSON.stringify(job))

      const taskIndex = newJob.tasks.findIndex(({ id }) => id === currentTaskID)
      if (taskIndex >= 0) {
        const evtTaskIndex = newJob.tasks[taskIndex].evt_tasks.findIndex(
          ({ id }) => id === currentEvtTaskID,
        )

        if (evtTaskIndex >= 0) {
          const evtTask = newJob.tasks[taskIndex].evt_tasks[evtTaskIndex]
          const currentEvtInputs = evtTask.evt_inputs || []

          const newEvtInputs = [...currentEvtInputs]

          evtInputs.forEach(evtInput => {
            const index = newEvtInputs.findIndex(({ id }) => id === evtInput)
            if (index >= 0) {
              newEvtInputs[index] = {
                ...newEvtInputs[index],
                result,
              }
            } else {
              newEvtInputs.push({ id: evtInput, input: inputId, result })
            }
          })

          evtTask.evt_inputs = newEvtInputs
        }
      }

      return state.set('jobTask', Map(newJob))
    },
    [SET_EVT_INPUT_RESULT]: (state, { payload }) => {
      const {
        currentTaskID,
        currentEvtTaskID,
        evtInputId,
        inputId,
        result,
        conditionalItems,
        populatedEvtInputs,
        clearedPopulatedEvtInputIds,
      } = payload
      const job = state.get('jobTask').toObject()
      const newJob = JSON.parse(JSON.stringify(job))

      const taskIndex = newJob.tasks.findIndex(({ id }) => id === currentTaskID)
      if (taskIndex >= 0) {
        const evtTaskIndex = newJob.tasks[taskIndex].evt_tasks.findIndex(
          ({ id }) => id === currentEvtTaskID,
        )

        if (evtTaskIndex >= 0) {
          const evtTask = newJob.tasks[taskIndex].evt_tasks[evtTaskIndex]
          const currentEvtInputs = evtTask.evt_inputs || []

          let newEvtInputs = [...currentEvtInputs]

          const index = newEvtInputs.findIndex(({ id }) => id === evtInputId)
          if (index >= 0) {
            newEvtInputs[index] = {
              ...newEvtInputs[index],
              result,
              ...(conditionalItems ? { conditionalItems } : {}),
            }
          } else {
            newEvtInputs.push({
              id: evtInputId,
              input: inputId,
              result,
              ...(conditionalItems ? { conditionalItems } : {}),
            })
          }

          newEvtInputs = clearPopulatedEvtInputsFromEvtInputs(
            newEvtInputs,
            clearedPopulatedEvtInputIds,
          )

          newEvtInputs = applyPopulatedEvtInputsToEvtInputs(
            newEvtInputs,
            populatedEvtInputs,
          )

          evtTask.evt_inputs = newEvtInputs
        }
      }

      return state.set('jobTask', Map(newJob))
    },
    [CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default myJobs
